import React from "react";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";

function ProjectList({ title, projects }) {
    const linkStyle = {
        textDecoration: "none",
        color: "white",
        fontSize: "1.05rem",
        transition: "color 0.3s ease",
    };
    const handleMouseEnter = (event) => {
        event.target.style.color = "#a682b3";
        event.target.style.fontSize = "1.12rem"
    };

    const handleMouseLeave = (event) => {
        event.target.style.color = "white";
        event.target.style.fontSize = "1.05rem"
    };
    return (
        <Card className="project-card-view project-list-card">
            <Card.Body>
                <strong className="purple"> <Card.Title>{title}</Card.Title></strong>
                <ListGroup variant="flush" style={{ backgroundColor: "transparent" }}>
                    {projects.map((project, index) => (
                        <ListGroup.Item key={index} className="project-list-item" style={{ backgroundColor: "transparent" }}>
                            <a
                                href={project.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={linkStyle}
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                            >
                                {project.title}
                            </a>
                            {"\n"}
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Card.Body>
        </Card>
    );
}

export default ProjectList;
